var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditpencilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9997 8.33424L11.6664 5.0009M2.08301 17.9176L4.90332 17.6042C5.24789 17.5659 5.42017 17.5467 5.58122 17.4947C5.72408 17.4484 5.86005 17.3831 5.98542 17.3004C6.12672 17.2072 6.24929 17.0847 6.49445 16.8395L17.4997 5.83424C18.4202 4.91376 18.4202 3.42138 17.4997 2.5009C16.5792 1.58043 15.0869 1.58043 14.1664 2.5009L3.16112 13.5062C2.91597 13.7513 2.79338 13.8738 2.70021 14.0152C2.61753 14.1406 2.55218 14.2765 2.50593 14.4194C2.45381 14.5804 2.43466 14.7527 2.39637 15.0972L2.08301 17.9176Z",
    stroke: "#404040",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditpencilIcon);
export default __webpack_public_path__ + "static/media/editpencilIcon.aa0b18aa8283739df6a9607a6fe7b6f1.svg";
export { ForwardRef as ReactComponent };